import { useEffect, useState, useContext, memo, useMemo, useRef } from "react";
import { capitalizeFirstLetter, fetchGet, fetchPost, fetchPut, getStringHash } from "../util/helpers";
import toast, { Toaster } from "react-hot-toast";
import {Button} from "../components";
import { useNavigate } from "react-router-dom";
import UserContext from "../contexts/UserContext";

import {
  Avatar,
  Box,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tabs,
  Tab,
  TextField,
  Typography,
  InputAdornment,
} from "@mui/material";
import outreachEmail from "../assets/Gigl Email Outreach.PNG";
import { IconMail, IconSearch } from "@tabler/icons-react";
import { useTheme } from "@mui/material";
import OutreachDrawer from "./OutreachDrawer";

const followerComparator = (a, b) => {
  return followerCountToNumber(a) - followerCountToNumber(b);
};
const followerCountToNumber = (followers) => {
  let amountMultiplier = followers.slice(-1).toLowerCase();
  if (amountMultiplier === "k") {
    amountMultiplier = 1000;
  } else if (amountMultiplier === "m") {
    amountMultiplier = 1000000;
  } else {
    amountMultiplier = 1;
  }
  const amount = parseFloat(followers.slice(0, -1));
  return amount * amountMultiplier;
};

// TabPanel component for handling tab content
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`outreach-tabpanel-${index}`}
      aria-labelledby={`outreach-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function NewOutreachTable(props) {
  const {
    campaignId,
    outreach: outreachFromParent,
    setOutreach: setOutreachFromParent,
    outreachLoading = false,
    onRefreshOutreach,
    nameSearch: nameSearchProp,
    setNameSearch: setNameSearchProp,
  } = props;
  const [localOutreach, setLocalOutreach] = useState([]);
  const [localNameSearch, setLocalNameSearch] = useState("");
  const isControlled = outreachFromParent !== undefined;
  const outreach = isControlled ? outreachFromParent : localOutreach;
  const setOutreach = isControlled ? (setOutreachFromParent || (() => {})) : setLocalOutreach;
  const searchControlled = nameSearchProp !== undefined;
  const nameSearch = searchControlled ? nameSearchProp : localNameSearch;
  const setNameSearch = searchControlled ? (setNameSearchProp || (() => {})) : setLocalNameSearch;
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmCreatorCardOpen, setConfirmCreatorCardOpen] = useState(false);
  const [creatorName, setCreatorName] = useState("");
  const [creatorId, setCreatorId] = useState("");
  const [creatorEmail, setCreatorEmail] = useState("");
  const [creatorLink, setCreatorLink] = useState("");
  const [creatorData, setCreatorData] = useState(null);
  const [creatorHandle, setCreatorHandle] = useState("");
  const [creatorIndustry, setCreatorIndustry] = useState("");
  const [creatorLocation, setCreatorLocation] = useState("");
  const [creatorCity, setCreatorCity] = useState("");
  const [creatorRelevance, setCreatorRelevance] = useState("");
  const [creatorFollowers, setCreatorFollowers] = useState("");
  const [creatorReach, setCreatorReach] = useState("");
  const [creatorLevelRelevance, setCreatorLevelRelevance] = useState("any");
  const [creatorLevelOutreach, setCreatorLevelOutreach] = useState("any");
  const [creatorGenderSearch, setCreatorGenderSearch] = useState("any");
  const [creatorEthnicitySearch, setCreatorEthnicitySearch] = useState("any");
  const [creatorAudienceTier, setCreatorAudienceTier] = useState("any");
  const [locationSearch, setLocationSearch] = useState("");
  const navigate = useNavigate();
  const [contactStatus, setContactStatus] = useState("any");
  const [favoriteOutreach,setFavoriteOutreach] = useState([]);
  const [isFavorite, setIsFavorite] = useState({});
  const [customText, setCustomText] = useState("");
  const [tabValue, setTabValue] = useState(0);
  const [customEmailMessage, setCustomEmailMessage] = useState("");
  const [isSendingEmail, setIsSendingEmail] = useState(false);
  const isSendingEmailRef = useRef(false);
  const { user } = useContext(UserContext);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const theme = useTheme();

  const STATUS_TO_LABEL = {
    "not-contacted": "Not contacted",
    delivered: "Delivered",
    opened: "Opened",
    clicked: "Clicked",
    failed: "Failed",
  };
  
  const STATUS_TO_COLOR = {
    "not-contacted": {backgroundColor: theme.palette.info.light, color: theme.palette.info.main},
    delivered: {backgroundColor: theme.palette.success.light, color: theme.palette.success.light},
    opened: {backgroundColor: "#6bc1ff", color: "#135687"}, //Blue, no blue option in our palette so this is custom 
    clicked: {backgroundColor: theme.palette.secondary.light, color: theme.palette.secondary.main},
    failed: {backgroundColor: theme.palette.error.light, color: theme.palette.error.main},
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const headers = [ "Creator", "Followers", "Industry", "Location", "Relevance", "Outreach Status", "Actions" ]

  const fetchOutreach = () => {
    if (onRefreshOutreach) {
      onRefreshOutreach();
      return;
    }
    fetchGet(`/brand/outreach?campaignId=${campaignId}`)
      .then((result) => result.result)
      .then((result) => {
        setOutreach(result.map((res) => ({ ...res, id: res.email })));
      });
  };
  const fetchFavoriteOutreach = async () => {
    const data = await fetchGet(`/brand/outreach/favorite/${user.userDocId}`);
    setFavoriteOutreach(data?.data || []);
  }
  const sendEmail = () => {
    // Prevent double sending
    if (isSendingEmailRef.current) {
      return;
    }
    isSendingEmailRef.current = true;
    setIsSendingEmail(true);
    
    const body = {
      campaignId: campaignId,
      email: creatorEmail,
    };
    
    if (tabValue === 0) {
      // Template email with optional custom text
     
    } else {
      // Custom email
      body.isCustomEmail = true;
      body.message = customEmailMessage;
    }
    
    fetchPost(`/brand/outreach`, body)
      .then(() => {
        toast.success(
          `Successfully sent an email to ${creatorName}. Check the status of this email in your outreach table.`,
        );
        setConfirmOpen(false);
        setCustomText("");
        setCustomEmailMessage("");
        setTabValue(0);
        if (onRefreshOutreach) onRefreshOutreach();
        else fetchOutreach();
      })
      .catch(() => {
        toast.error(
          `Failed to send an email to ${creatorName}. Please check back later.`,
        );
      })
      .finally(() => {
        isSendingEmailRef.current = false;
        setIsSendingEmail(false);
      });
  };

  useEffect(() => {
    if (!isControlled) fetchOutreach();
    if (user?.userDocId) fetchFavoriteOutreach();
  }, [campaignId, isControlled]);


  const closeDialog = () => {
    setConfirmOpen(false);
    setCreatorEmail("");
    setCreatorName("");
    setCustomText("");
    setCustomEmailMessage("");
    setTabValue(0);
  };

  const closeCreatorCardDialog = () => {
    setConfirmCreatorCardOpen(false);
    setCreatorEmail("");
    setCreatorName("");
    setCreatorLink("");
    setCreatorData({});
    setCreatorHandle("");
    setCreatorLocation("");
    setCreatorCity("");
    setCreatorRelevance("");
    setCreatorFollowers("");
    setCreatorReach("");
    setIsFavorite({});
  };

  const checkIsFavoriteCreator = (selectedCreator) => {
    const favoriteData = favoriteOutreach.filter((data)=>data.outreach_emailid === selectedCreator.email);
    setIsFavorite(favoriteData[0]||{});
  }
  
  const handleFavorite = async (status) => {
    if(!isFavorite.id){
      const result = await fetchPost("/brand/outreach/favorite",{
        "outreach_emailid":creatorData.email,
        "favorite_status":status
      });
      const resultData = {...result.data};
      const newList = [...favoriteOutreach];
      newList.push({...resultData});

      setFavoriteOutreach([...newList]);
      setIsFavorite({...resultData});
    }else{
      const result = await fetchPut(`/brand/outreach/favorite/${isFavorite.id}`,{...isFavorite,"favorite_status":status});
      const resultData = {...result.data};
      const newList = favoriteOutreach.map((data)=>data.id === isFavorite.id? {...resultData}:{...data});
      setFavoriteOutreach([...newList]);
      setIsFavorite({...resultData});
    }
  }
  const rows = useMemo(() => {
    const checkName = (row) => {
      if (nameSearch) {
        const name = (row?.name ?? "").toLowerCase();
        const handle = (row?.handle ?? "").toLowerCase();
        const search = nameSearch.toLowerCase();
        if (name.includes(search) || handle.includes(search)) {
          return true;
        }
        return false;
      }
      return true;
    }
    
    // Define status priority for sorting (lower number = higher priority)
    const statusPriority = {
      "not-contacted": 5,
      "delivered": 4,
      "opened": 3,
      "clicked": 2,
      "failed": 1,
    };
    
    // Filter and sort by outreach status
    return outreach
      .filter(checkName)
      .sort((a, b) => {
        const priorityA = statusPriority[a.status] || 999;
        const priorityB = statusPriority[b.status] || 999;
        return priorityA - priorityB;
      });
  }, [outreach, nameSearch]);

  return (
    <Box sx={{ width: "100%" }}>
      <OutreachDrawer campaignId={campaignId} open={confirmCreatorCardOpen} onClose={() => setConfirmCreatorCardOpen(false)} creator={creatorData} setCreator={setCreatorData}/>
      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)} fullWidth maxWidth="md">
        <DialogTitle>
          Outreach To This Creator
        </DialogTitle>
        <DialogContent>
          <Tabs 
            value={tabValue} 
            onChange={(e, newValue) => setTabValue(newValue)} 
            aria-label="outreach tabs"
            sx={{ borderBottom: 1, borderColor: 'divider' }}
          >
            <Tab label="Use Template" id="outreach-tab-0" aria-controls="outreach-tabpanel-0" />
            <Tab label="Custom Email" id="outreach-tab-1" aria-controls="outreach-tabpanel-1" />
          </Tabs>
          
          <TabPanel value={tabValue} index={0}>
            <Typography variant="body2" sx={{ mb: 2 }}>
              By outreaching to a creator, you are inviting them to apply for your
              campaign using Gigl's customized email template. If this creator is interested in working with you, they will
              show up in your applications section above.
            </Typography>
            <img
              alt="outreach-email"
              src={outreachEmail}
              height="100%"
              style={{
                maxHeight: 700,
                maxWidth: 750,
                width: '100%',
                objectFit: 'contain'
              }}
            />
          
          </TabPanel>
          
          <TabPanel value={tabValue} index={1}>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Write a custom email message to {creatorName}. This will be sent from a Gigl email. To send a custom email from your email address, click the Learn More button and select 'Send a Custom Email'. 
              <br/>              
              <br/>

              Subject Line: Collaboration Opportunity with [Your Brand Name]
            </Typography>
            <TextField
              multiline
              minRows={8}
              fullWidth
              value={customEmailMessage}
              onChange={(e) => setCustomEmailMessage(e.target.value)}
              placeholder="Write your custom email message here..."
              required
            />
          </TabPanel>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog}>Cancel</Button>

          <Button
            onClick={sendEmail}
            disabled={isSendingEmail || (tabValue === 1 && (!customEmailMessage.trim()))}
            style={{
              backgroundColor: "#4158D0",
              backgroundImage:
                "linear-gradient(120deg, #fccb90 0%, #d57eeb 100%)",
            }}
          >
            {isSendingEmail ? "Sending..." : "Send Email"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Search bar - only when not controlled by parent */}
      {!searchControlled && (
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="flex-end" sx={{ mb: 2 }}>
          <TextField
            placeholder="Search creators by name or handle..."
            size="small"
            variant="outlined"
            value={nameSearch}
            onChange={(e) => setNameSearch(e.target.value)}
            sx={{
              maxWidth: 320,
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
                backgroundColor: "#fff",
                "& fieldset": { borderColor: "var(--neutral-200)" },
                "&:hover fieldset": { borderColor: "var(--secondary-300)" },
              },
            }}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <IconSearch size={18} color="var(--body-text-color-500)" />
                  </InputAdornment>
                ),
              },
            }}
          />
        </Stack>
      )}

      {/* Table card */}
      <Box
        sx={{
          background: "#fff",
          borderRadius: "12px",
          border: "1px solid var(--neutral-200)",
          overflow: "hidden",
          boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
        }}
      >
        {outreachLoading ? (
          <Stack alignItems="center" justifyContent="center" sx={{ minHeight: 280, py: 6 }} spacing={2}>
            <CircularProgress sx={{ color: "var(--secondary-500)" }} />
            <Typography variant="body2" sx={{ color: "var(--body-text-color-500)" }}>
              Loading outreach...
            </Typography>
          </Stack>
        ) : (
          <>
            <TableContainer>
              <Table sx={{ minWidth: 720 }}>
                <TableHead>
                  <TableRow
                    sx={{
                      backgroundColor: "var(--neutral-50)",
                      "& th": {
                        borderBottom: "1px solid var(--neutral-200)",
                        py: 1,
                        px: 2,
                      },
                    }}
                  >
                    {headers.map((header) => (
                      <TableCell key={header}>
                        <Typography
                          variant="caption"
                          sx={{
                            fontWeight: 700,
                            color: "var(--body-text-color-600)",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                            fontSize: "0.7rem",
                          }}
                        >
                          {header}
                        </Typography>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={headers.length} align="center" sx={{ py: 6 }}>
                        <Typography variant="body2" sx={{ color: "var(--body-text-color-500)" }}>
                          {nameSearch ? "No creators match your search." : "No creators in your outreach list yet."}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    rows
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((creator) => (
                        <TableRow
                          key={creator.email || creator.id}
                          sx={{
                            "&:hover": { backgroundColor: "var(--neutral-50)" },
                            transition: "background 0.2s ease",
                            "& td": {
                              borderBottom: "1px solid var(--neutral-100)",
                              py: 1,
                              px: 2,
                            },
                          }}
                        >
                          <TableCell align="left" width="20%">
                            <Stack
                              direction="row"
                              spacing={2}
                              alignItems="center"
                              onClick={() => {
                                setConfirmCreatorCardOpen(true);
                                setCreatorData(creator);
                              }}
                              sx={{
                                cursor: "pointer",
                                "&:hover .creator-name": { color: "var(--secondary-600)" },
                              }}
                            >
                              <Avatar
                                src={
                                  creator?.profileImage
                                    ? creator.profileImage
                                    : `../gradient${getStringHash(creator?.name, 10)}.png`
                                }
                                alt={creator.name}
                                sx={{
                                  width: 40,
                                  height: 40,
                                  border: "2px solid var(--neutral-100)",
                                }}
                              />
                              <Stack direction="column" spacing={0}>
                                <Typography
                                  className="creator-name"
                                  variant="body2"
                                  sx={{
                                    fontWeight: 600,
                                    color: "var(--main-text-color)",
                                    transition: "color 0.2s ease",
                                  }}
                                >
                                  {creator.name}
                                </Typography>
                              </Stack>
                            </Stack>
                          </TableCell>
                          <TableCell align="left" width="12%">
                            <Typography variant="body2" sx={{ color: "var(--main-text-color)" }}>
                              {creator.followers}
                            </Typography>
                          </TableCell>
                          <TableCell align="left" width="20%">
                            <Typography variant="body2" sx={{ color: "var(--main-text-color)" }}>
                              {(() => {
                                const raw = creator.industry;
                                const list = Array.isArray(raw)
                                  ? raw.map((s) => capitalizeFirstLetter(String(s)))
                                  : (raw || "")
                                      .split(",")
                                      .map((s) => capitalizeFirstLetter(s.trim()))
                                      .filter(Boolean);
                                return list.length ? list.join(", ") : "—";
                              })()}
                            </Typography>
                          </TableCell>
                          <TableCell align="left" width="12%">
                            <Typography variant="body2" sx={{ color: "var(--main-text-color)" }}>
                              {creator.location?.join(", ") || "—"}
                            </Typography>
                          </TableCell>
                          <TableCell align="left" width="12%">
                            <Typography variant="body2" sx={{ color: "var(--main-text-color)" }}>
                              {creator.relevance?.join(", ") || "—"}
                            </Typography>
                          </TableCell>
                          <TableCell align="left" width="12%">
                            <Chip
                              size="small"
                              label={STATUS_TO_LABEL[creator.status]}
                              sx={{
                                ...STATUS_TO_COLOR[creator.status],
                                fontWeight: 600,
                                borderRadius: "8px",
                                fontSize: "0.7rem",
                              }}
                            />
                          </TableCell>
                          <TableCell align="left" width="12%" sx={{ whiteSpace: "nowrap" }}>
                            <Stack direction="row" spacing={1} flexWrap="nowrap" alignItems="center">
                              <Button
                                size="small"
                                onClick={() => {
                                  setConfirmCreatorCardOpen(true);
                                  setCreatorData(creator);
                                }}
                                variant="outlined"
                                className="outlined-button"
                                color="info"
                                sx={{ borderRadius: "10px", fontWeight: 600, textTransform: "none", minWidth: "fit-content", flexShrink: 0 }}
                              >
                                Learn More
                              </Button>
                              <Button
                                size="small"
                                onClick={() => {
                                  setConfirmOpen(true);
                                  setCreatorName(creator.name);
                                  setCreatorEmail(creator.email);
                                }}
                                variant="outlined"
                                className="outlined-button"
                                color="info"
                                startIcon={<IconMail size={16} color={theme.palette.info.main} />}
                                sx={{ borderRadius: "10px", fontWeight: 600, textTransform: "none", minWidth: "fit-content", flexShrink: 0 }}
                              >
                                Outreach
                              </Button>
                            </Stack>
                          </TableCell>
                        </TableRow>
                      ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              count={rows.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{
                borderTop: "1px solid var(--neutral-100)",
                ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": {
                  fontSize: "0.8rem",
                  color: "var(--body-text-color-600)",
                },
              }}
            />
          </>
        )}
      </Box>
      <Toaster position="top-center" toastOptions={{ duration: 3000 }} />
     

      <Toaster
        position="top-center"
        toastOptions={{ duration: 3000 }}
        style={{ width: 5000 }}
      />
    </Box>
  );
}

export default memo(NewOutreachTable);